import { ca } from '@cian/analytics';

import { getNewbuildingBrokerGaLabel, getNewbuildingBrokerProducts } from './utils';
import { INewbuildingBrokerCallbackWidget } from 'shared/types/newbuildingBrokerCallbackWidget';

export const trackCallbackWidgetOpen = (offerInfo: INewbuildingBrokerCallbackWidget['offerInfo']) => {
  ca('eventSite', {
    name: 'oldevent',
    action: 'Booking_click_label',
    category: 'Listing',
    label: getNewbuildingBrokerGaLabel(offerInfo),
    products: getNewbuildingBrokerProducts(offerInfo),
    page: {
      extra: {
        listing_label: true,
      },
    },
  });
};
